import Vue from 'vue';
import ToolBar from '../../parts/ToolBar.vue';
import Theme from '../../../raccoonTheme';
export default Vue.extend({
    components: { ToolBar },
    name: "WalletDetail",
    props: {
        id: String
    },
    data() {
        return {
            loading: true,
            styles: {
                header: {
                    backgroundColor: Theme.primary
                }
            }
        };
    },
    methods: {
        openLink(url) {
            window.open(url);
        }
    },
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/about/AboutThisApp.vue
// module id = 656
// module chunks = 1